import { Injectable }  from '@angular/core';
import { Http }  from '@angular/http';

import { CookieUtils } from '../shared/cookieutils';

import {BaseService} from './base.service';
import {BaseServiceExceptionHandler} from './base-service-exception-handler';

@Injectable()
export class GetSeasonsForLeagueService extends BaseService {

	constructor($http: Http, $cookies: CookieUtils, BaseServiceExceptionHandler: BaseServiceExceptionHandler) {
		super($http, $cookies, BaseServiceExceptionHandler);
	}

    public get(leagueId: number) {
        let urlStr: string = 'league/' + leagueId + '/seasons/all';

	    return this.sendRequest('GET',
                                urlStr,
                         	    null,
                                null,
                                false);
    }

}
